export class SubFloorTowerModel {
    constructor(public id: string, public unit: string, full_address: string) {}
}